/********************************************************************
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  Adobe permits you to use, modify, and distribute this 
 * file in accordance with the terms of the Adobe license agreement 
 * accompanying it. 
 *******************************************************************/

/**
 * Convert locale from Magento standard to react-intl BCP 47 language tag
 *
 * @param {string} locale - A locale (e.g. `fr_FR`).
 * @returns {string} A BCP 47 language tag (e.g. `fr-FR`).
 */
export const toLanguageTag = (locale: string) => {
  return locale.replace('_', '-');
};
